import {ButtonHTMLAttributes, forwardRef, memo} from 'react';

import styled from 'styled-components';

import Button, {IButton} from '~/shared/components/Button';
import {FlexCenter} from '~/shared/theme/FlexLayout';
import {SimpleSpinnerLoader} from '~/shared/components/Loaders';

import {PieButtonVariant} from './types';
import {pieButtonLoaderColorMap, pieButtonStylesMap} from './consts';

const getPieButtonStyle = (variant: PieButtonVariant) => pieButtonStylesMap[variant];

const getPieButtonLoaderColor = (variant: PieButtonVariant) => pieButtonLoaderColorMap[variant];

const StyledButton = styled(Button)<{variant: PieButtonVariant; isLoading: boolean; disabled: boolean}>`
  position: relative;
  ${({variant}) => getPieButtonStyle(variant)}
`;

const LoaderContainer = styled(FlexCenter)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const ContentContainer = styled(FlexCenter)<{isHidden: boolean}>`
  visibility: ${({isHidden}) => (isHidden ? 'hidden' : 'visible')};
`;

type PieButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & IButton & {
  variant: PieButtonVariant;
  iconButton?: boolean;
  isLoading?: boolean;
};

const PieButton = forwardRef<HTMLButtonElement, PieButtonProps>(({variant, isLoading, disabled, children, ...props}, ref) => {
  return (
    <StyledButton
      ref={ref}
      {...props}
      variant={variant}
      isLoading={!!isLoading}
      disabled={disabled || isLoading}
      ignoreDisabledStyle
    >
      <ContentContainer className="button-content-container" isHidden={!!isLoading}>
        {children}
      </ContentContainer>
      {isLoading && (
        <LoaderContainer>
          <SimpleSpinnerLoader variant={getPieButtonLoaderColor(variant)} />
        </LoaderContainer>
      )}
    </StyledButton>
  );
});

export default memo(PieButton);
